export default {
  message: {
    "error": "একটি ত্রুটি হয়েছে!",
    "Sorrysomeerrorsoccurred": "দুঃখিত কিছু ত্রুটি ঘটেছে",
    "quit": "বেরিয়ে যান",
    "language": "ভাষা",
    "Youcanchangethelanguagehere": "আপনি এখানে ভাষা পরিবর্তন করতে পারেন!",
    "current": "বর্তমান",
    "home": "বাড়ি",
    "friends": "বন্ধুরা",
    "wallet": "ওয়ালেট",
    "aboutus": "আমাদের সম্পর্কে",
    "Sharewithfriends": "বন্ধুদের সাথে শেয়ার করুন",
    "copyFailure": "কপি ব্যর্থ",
    "copySuccess": "কপি সফল",
    "Claimreward": "পুরস্কার গ্রহন করুন",
    "DailyLogin": "দৈনিক লগইন",
    "noInvitationsYet": "এখনও কোন আমন্ত্রণ নেই",
    "LoadMore": "আরো লোড করুন",
    "WatchAD": "এড দেখুন",
    "continue": "চালিয়ে যান",
    "Congratulations": "অভিনন্দন",
    "MyFriends": "আমার বন্ধুরা",
    "Invitefriends": "বন্ধুদের আমন্ত্রণ জানাতে",
    "Invitepremiumfriends": "প্রিমিয়াম বন্ধুদের আমন্ত্রণ জানাতে",
    "DailyTasks": "দৈনিক কাজ",
    "inviteDesc": "প্রতি বন্ধুর জন্য +{num} ${name}",
    "DailyTasksDesc": "আরো ${name} পেতে কাজ সম্পন্ন করুন",
    "SponsorsandPartners": "স্পনসর এবং অংশীদার",
    "Receivingwallet": "গ্রহণকারী ওয়ালেট",
    "Enterwalletaddress": "{name} ওয়ালেট ঠিকানা প্রবেশ করুন",
    "Claim": "পুরস্কার গ্রহন করুন",
    "Booster": "বুস্টার",
    "RentPeriod": "ভাড়ার সময়কাল",
    "days30": "৩০ দিন",
    "days": "দিন",
    "Dailyprofit": "দৈনিক মুনাফা",
    "Totalprofit": "মোট মুনাফা",
    "Quantity": "পরিমাণ",
    "RentPrice": "ভাড়ার দাম",
    "RentMiner": "খননকারী ভাড়া করুন",
    "Insufficient": "অপর্যাপ্ত ${name}",
    "InsufficientMsg": "প্রয়োজন {num} ${name1} , আরো ${name2} উপার্জন করতে বন্ধুদের আমন্ত্রণ জানান অথবা কাজ সম্পন্ন করুন।",
    "Settings": "সেটিংস",
    "copyid": "আইডি কপি করুন",
    "UpgradeSuccessfully": "সফলভাবে আপগ্রেড",
    "Name": "নাম",
    "userinfo": "ব্যবহারকারীর তথ্য",
    "disconnect": "সংযোগ বিচ্ছিন্ন করুন",
    "Startmining": "খনন শুরু করুন",
    "Welcome": "{name} -এ স্বাগতম",
    "Withdrawal": "উত্তোলন",
    "Minimumamount": "সর্বনিম্ন পরিমাণ",
    "Networkfee": "নেটওয়ার্ক ফি",
    "Enteramount": "পরিমাণ প্রবেশ করুন",
    "Submit": "জমা দিন",
    "MinimumTip": "উত্তোলনের পরিমাণ খুবই ছোট। ন্যূনতম উত্তোলনের পরিমাণ: {num}",
    "MaximumTip": "অপর্যাপ্ত পরিমাণ, আপনি উত্তোলন করতে পারেন সর্বাধিক পরিমাণ: {num}",
    "SubmittedTip": "জমা দেওয়া হয়েছে, 30-60 কর্মদিবসের মধ্যে প্রক্রিয়াকৃত হবে বলে আশা করা হচ্ছে",
    "WebSubmittedTip": "জমা দেওয়া হয়েছে, 24-48 ঘণ্টার মধ্যে প্রক্রিয়াকৃত হবে বলে আশা করা হচ্ছে",
    "WithdrawStatus": "অবস্থা",
    "Submissiontime": "জমা দেওয়ার সময়",
    "WithdrawAwaitTip": "* এটি প্রায় 30-60 কর্মদিবস লাগবে বলে আশা করা হচ্ছে। আরো বন্ধুদের আমন্ত্রণ জানানো হলে পর্যালোচনা প্রক্রিয়া দ্রুত হবে।",
    "WebWithdrawAwaitTip": "* এটি প্রায় 24-48 ঘণ্টা লাগবে বলে আশা করা হচ্ছে। আরো বন্ধুদের আমন্ত্রণ জানানো হলে পর্যালোচনা প্রক্রিয়া দ্রুত হবে।",
    "Processing": "প্রক্রিয়াকরণ হচ্ছে",
    "Success": "সফল",
    "Rejection": "অগ্রাহ্য",
    "Amount": "পরিমাণ",
    "Numberoffriends": "বন্ধুর সংখ্যা: {now}/{limit}",
    "InviteTip": "আপনার প্রথম উত্তোলন করতে, আপনাকে {limit} বন্ধুকে খনির অ্যাপে যোগ দিতে আমন্ত্রণ জানাতে হবে।",
    "openonphone": "আপনার ফোনে এই লিঙ্কটি খোলুন।",
    "claimTip": "Claim করার জন্য পরিমাণটি খুবই ছোট। Claim করার জন্য ন্যূনতম পরিমাণ হলো: {num}",
    "WalletBalance": "ওয়ালেট ব্যালেন্স",
    "Withdraw": "উত্তোলন করুন",
    "SetWalletAddress": "ওয়ালেট ঠিকানা সেট করুন",
    "WithdrawalRecord": "উত্তোলন রেকর্ড",
    "Norecords": "রেকর্ড নেই",
    "Whatis": "{name} কি?",
    "All": "সব",
    "save": "সংরক্ষণ করুন",
    "successWithdrawal": "উত্তোলন গ্রহণ করা হয়েছে {num}",
    "secondsago": "{time} সেকেন্ড আগে",
    "Loading": "লোড হচ্ছে...",
    "PaymentConfirming": "লেনদেনের অবস্থা যাচাই করা হচ্ছে...",
    "Check": "যাচাই করুন",
    "CheckFail": "লেনদেন সম্পন্ন হয়নি। দয়া করে 5 সেকেন্ড পর আবার চেক করুন।",
    "Addname": "'{name}' আপনার নামে যোগ করুন",
    "Restattcheck": "যাচাই করতে অ্যাপটি পুনরায় শুরু করুন",
    "Copyname": "'{name}' কপি করুন",
    "SubmissionFailed": "জমা দেওয়া ব্যর্থ, দয়া করে পরে আবার চেষ্টা করুন",
    "WithdrawalReview": "উত্তোলন পর্যালোচনা",
    "shop": "দোকান",
    "topurchase": "ক্রয় করতে দোকানে যান",
    "shopDesc": "সীমিত উপলব্ধতা—এগুলি চলে যাওয়ার আগে আপনারটা পেয়ে নিন!",
    "select_payment_method": "পেমেন্ট পদ্ধতি নির্বাচন করুন",
    "total_amount": "মোট পরিমাণ",
    "creating_order": "অর্ডার তৈরি হচ্ছে...",
    "order_created": "অর্ডার তৈরি হয়েছে",
    "order_status": "অর্ডারের অবস্থা",
    "claim": "Collect rewards",
    "payment_success": "পেমেন্ট সফল",
    "payment_failed": "পেমেন্ট ব্যর্থ",
    "payment_cancelled": "পেমেন্ট বাতিল",
    "opening_payment": "পেমেন্ট খোলার চেষ্টা করা হচ্ছে...",
    "payment_status": "পেমেন্টের অবস্থা",
    "create_order_failed": "অর্ডার তৈরি করা ব্যর্থ",
    "creating_ton_order": "TON অর্ডার তৈরি করা হচ্ছে...",
    "next_step": "পরবর্তী পদক্ষেপ",
    "use_ton_payment": "TON পেমেন্ট ব্যবহার করুন",
    "start_transaction": "লেনদেন শুরু করুন",
    "connect_wallet": "ওয়ালেট সংযুক্ত করুন",
    "address": "ঠিকানা",
    "amount_ton": "রাজস্ব TON",
    "copy": "কপি",
    "amount": "পরিমাণ",
    "wallet_address": "ওয়ালেটের ঠিকানা",
    "comment_memo": "মন্তব্য মেমো",
    "you_can_choose_to_connect_wallet_to_pay": "পেমেন্টের জন্য ওয়ালেট সংযুক্ত করার জন্য আপনি নির্বাচন করতে পারেন",
    "or_manually_transfer_to_the_above_address": "অথবা উপরের ঠিকানায় ম্যানুয়ালি স্থানান্তর করুন (নোট করুন যে পরিমাণ এবং মেমো একেবারেই একই হতে হবে)",
    "transaction_success": "লেনদেন সফল",
    "transaction_failed": "লেনদেন ব্যর্থ",
    "transaction_error": "লেনদেন ত্রুটি",
    "transaction_status": "লেনদেনের অবস্থা",
    "transaction_id": "লেনদেন আইডি",
    "transaction_amount": "লেনদেনের পরিমাণ",
    "transaction_status_desc": "লেনদেনের অবস্থা বর্ণনা",
    "payment_status_tip": "পেমেন্ট নিশ্চিত হওয়ার জন্য দয়া করে অপেক্ষা করুন",
    "Applyforwithdrawal": "অবিলম্বে তোলার জন্য আবেদন করুন",
    "Withdrawalunlock": "উত্তোলনের আনলক করা হচ্ছে",
    "Close": "বন্ধ করুন",
    "Delivering": "ডেলিভারি করা হচ্ছে",
    "Duetothelargenumber": "গ্রহণকারীদের বৃহৎ সংখ্যা হওয়ার কারণে, আপনার এয়ারড্রপ ১৫-২০ কর্মদিবসের মধ্যে আসার প্রত্যাশা করা হচ্ছে",
    "WithdrawalunlockTip": "আপনার উত্তোলন আনলক করতে কাজ সম্পন্ন করার জন্য {num} আমন্ত্রিত বন্ধু প্রয়োজন",
    "select_network": "নেটওয়ার্ক নির্বাচন করুন",
    "confirm": "নিশ্চিত করুন",
    "switching_network": "নেটওয়ার্ক পরিবর্তন হচ্ছে...",
    "network_switched": "নেটওয়ার্ক পরিবর্তিত হয়েছে",
    "use_usdt_payment": "USDT পেমেন্ট ব্যবহার করুন",
    "or_manually_transfer_to_the_above_address_usdt": "উপরের ঠিকানায় হাতে হস্তান্তর করুন (যত্ন নিন যে পরিমাণ এবং ঠিকানা অবশ্যই একেবারে একই হতে হবে)",
    "chain_type": "নেটওয়ার্ক",
    "check_transaction_status": "লেনদেনের স্থিতি চেক করুন",
    "transaction_wait": "লেনদেন প্রক্রিয়াধীন রয়েছে। আপনি অ্যাপটি বন্ধ করতে পারেন। এটি সম্পন্ন হলে একটি বার্তা আপনাকে জানিয়ে দেবে।",
    "twa_pay_tip_with_memo": "দয়া করে নিশ্চিত করুন যে ঠিকানা, পরিমাণ এবং নোট স্থানান্তরের জন্য সঙ্গতিপূর্ণ।",
    "twa_pay_tip": "দয়া করে নিশ্চিত করুন যে ঠিকানা এবং পরিমাণ স্থানান্তরের জন্য সঠিক।",
    "creating_usdt_order": "USDT অর্ডার তৈরি করা হচ্ছে...",
    "affiliate_programs": "অ্যাফিলিয়েট প্রোগ্রাম",
    "affiliate_programs_description": "বন্ধুকে মাইনিং অ্যাপে আমন্ত্রণ জানান এবং পুরস্কার অর্জন করুন।",
    "commission_details": "কমিশনের বিবরণ",
    "no_commission_records": "কোন কমিশন রেকর্ড নেই",
    "commission_list": "কমিশনের তালিকা",
    "input_amount": "পরিমাণ প্রবেশ করুন",
    "max": "সর্বাধিক",
    "commission_input_amount": "কমিশনের পরিমাণ প্রবেশ করুন",
    "min_commission": "সর্বনিম্ন উত্তোলন পরিমাণ হল {num}",
    "WithdrawalSuccess": "উত্তোলন সফল হয়েছে",
    "WithdrawalFailed": "উত্তোলন বিফল হয়েছে",
    "WithdrawalProcessing": "উত্তোলন প্রক্রিয়াকরণ চলছে",
    "award": "পুরস্কার",
    "level": "স্তর",
    "Share_to_group": "গ্রুপে শেয়ার করুন",
    "Exchange": "বদল",
    "balance_not_enough": "মাথাপিছু পর্যাপ্ত নয়, আপনি শুধুমাত্র {num} {coin} বদল করতে পারবেন",
    "exchange_fail": "বদল ব্যর্থ হয়েছে",
    "exchange_success": "বদল সফল হয়েছে",
    "you_will_receive": "আপনি পাবেন",
    "ShareToGroups": "গ্রুপে শেয়ার করুন",
    "Numberofgroups": "গ্রুপের সংখ্যা: {now}/{limit}",
    "Confirm": "নিশ্চিত করুন",
    "ShareToGroupsDesc": "আরও {name} পেতে গ্রুপে শেয়ার করুন",
    "TokenAddress": "অবসর নেওয়ার বিবরণ প্রবেশ করুন যেমন এক্সচেঞ্জ আইডি বা ইউএসডিটি ঠিকানা",
    "CashAddress": "অবসর নেওয়ার বিবরণ প্রবেশ করুন যেমন ব্যাংক কার্ড নম্বর বা ইউএসডিটি ঠিকানা",
    "Cancel": "বাতিল করুন",
    "min_withdrawal_amount": "ন্যূনতম নিষ্কাশনের পরিমাণ হল {num} {coin}",
    "max_withdrawal_amount": "সর্বাধিক নিষ্কাশনের পরিমাণ হল {num} {coin}",
    "withdrawal_failed": "নিষ্কাশন ব্যর্থ হয়েছে",
    "withdrawal_success": "অর্থ প্রত্যাহার সফল",
    "PayNow": "এখনই পরিশোধ করুন",
    "PaySkip": "তাত্ক্ষণিকভাবে উত্তোলন প্রদানের জন্য {num} পরিশোধ করুন",
    "NumberofGroups": "গোষ্ঠীর সংখ্যা: {now}/{limit}",
    "SendMessage": "বার্তা পাঠান",
    "NumberofShares": "শেয়ার সংখ্যা: {now}/{limit}",
    "NumberofTasks": "কর্মের সংখ্যা: {now}/{limit}",
    "CompleteTask": "কর্ম সম্পন্ন করুন",
    "PleaseEnterValidAmount": "দয়া করে বৈধ পরিমাণ প্রবেশ করুন",
    "PleaseEnterValidEmail": "দয়া করে বৈধ ইমেল প্রবেশ করুন",
    "Feedback": "মতামত",
    "Inputfeedbackcontent": "মতামত বিষয়বস্তু প্রবেশ করুন",
    "Submitfeedback": "মতামত জমা দিন",
    "Pleaseenteravalidemailaddress": "দয়া করে একটি বৈধ ইমেল ঠিকানা প্রবেশ করুন",
    "Pleaseenteryouremailaddress": "দয়া করে আপনার ইমেল ঠিকানা প্রবেশ করুন",
    "Youhavealreadyfeedbackedtoday_pleasecomebacktomorrow": "আপনি ইতিমধ্যে আজ মতামত দিয়েছেন, দয়া করে কাল ফিরুন",
    "Feedback_submitted_successfully_thank_you_for_your_valuable_feedback": "মতামত সফলভাবে জমা হয়েছে, আপনার মূল্যবান মতামতের জন্য ধন্যবাদ",
    "Feedback_submission_failed_please_retry": "মতামত জমা দিতে ব্যর্থ হয়েছে, দয়া করে আবার চেষ্টা করুন",
    "ContactUs": "আমাদের সাথে যোগাযোগ করুন",
    "XRPAddress": "আপনি সক্রিয় XRP চেইন ওয়ালেট ঠিকানা (MEMO অন্তর্ভুক্ত) পূরণ করুন, অন্যথায় আপনি নগদ তুলে নিতে পারবেন না।",
    "Accelerated": "ত্বরান্বিত",
    "Accelerated_withdrawals_success": "ত্বরান্বিত তোলাগুলি সফলভাবে",
    "login": "লগইন",
    "register": "নিবন্ধন করুন",
    "login_with_google": "গুগল দিয়ে লগইন করুন",
    "or": "অথবা",
    "email": "ইমেইল",
    "password": "পাসওয়ার্ড",
    "no_account": "একটি অ্যাকাউন্ট নেই",
    "click_to_go": "লিখুন",
    "have_account": "এরই মধ্যে একটি অ্যাকাউন্ট আছে",
    "go_to": "এতে যান",
    "invite_code": "আমন্ত্রণ কোড",
    "optional": "ঐচ্ছিক",
    "google_login_not_ready": "গুগল লগইন প্রস্তুত নেই, অনুগ্রহ করে পরে আবার চেষ্টা করুন",
    "password_too_long": "পাসওয়ার্ড খুব দীর্ঘ",
    "weak": "দুর্বল",
    "medium": "মধ্যম",
    "strong": "শক্তিশালী",
    "login_success": "লগইন সফল",
    "login_failed": "লগইন ব্যর্থ",
    "please_input_email": "অনুগ্রহ করে আপনার ইমেইল টাইপ করুন",
    "invalid_email": "অবৈধ ইমেইল ফরম্যাট",
    "please_input_password": "অনুগ্রহ করে আপনার পাসওয়ার্ড টাইপ করুন",
    "password_length_6_to_16": "পাসওয়ার্ড 6-16 অক্ষরের মধ্যে হতে হবে",
    "account_or_password_error": "অ্যাকাউন্ট বা পাসওয়ার্ড ত্রুটি",
    "register_success": "নিবন্ধন সফল",
    "register_failed": "নিবন্ধন ব্যর্থ",
    "save_error": "সংরক্ষণ ত্রুটি, দয়া করে পরে আবার চেষ্টা করুন",
    "ShareToFriends": "মিত্রদের সঙ্গে শেয়ার করুন",
    "login_first": "প্রথমে লগইন করুন",
    "WalletBscError": "❌ অবৈধ BNB চেইন ওয়ালেট ঠিকানা।",
    "DownloadWallet": "ওয়ালেট ডাউনলোড করুন",
    "AddToHomeScreen": "মূল পর্দায় {appName} যোগ করুন",
    "TapShareInToolbar": "টুলবারে ট্যাপ করুন",
    "SelectAddToHomeScreen": "মূল পর্দায় যোগ করতে নির্বাচন করুন",
    "OpenToolbar": "টুলবার খুলুন",
    "ClaimFailed": "পুরস্কার গ্রহণ ব্যর্থ হয়েছে, দয়া করে পরে আবার চেষ্টা করুন",
    "guest_login": "অতিথি লগইন",
    "please_input_phone": "দয়া করে আপনার ফোন নম্বর প্রবেশ করুন",
    "email_error_1": "দয়া করে আপনার ইমেইল প্রবেশ করুন",
    "email_error_2": "দয়া করে একটি বৈধ ইমেইল ঠিকানা প্রবেশ করুন",
    "email_error_3": "অতিথি ইমেইল অনুমোদিত নয়, দয়া করে একটি সত্যিকারের ইমেইল ব্যবহার করুন",
    "phone": "ফোন",
    "phone_error_1": "দয়া করে আপনার ফোন নম্বর প্রবেশ করুন",
    "phone_error_2": "দয়া করে একটি বৈধ ফোন নম্বর প্রবেশ করুন",
    "update_info": "তথ্য আপডেট করুন",
    "update_success": "আপডেট সফল",
    "update_failed": "আপডেট ব্যর্থ, দয়া করে পরে আবার চেষ্টা করুন",
    "cancel": "বাতিল করুন",
    "guest_credentials_title": "অ্যাকাউন্ট তথ্য",
    "guest_credentials_warning": "আপনার অ্যাকাউন্ট এবং পাসওয়ার্ড সংরক্ষণ করতে একটি স্ক্রীনশট নিন। যদি হারিয়ে যায়, আপনার উপার্জন পুনরুদ্ধার করা যাবে না!",
    "i_have_saved": "আমি সংরক্ষণ করেছি",
    "account": "অ্যাকাউন্ট",
    "view_credentials": "শংসাপত্র দেখুন",
    "miner_max_reached": "আপনি এই খনির সর্বাধিক সংখ্যায় পৌঁছেছেন"
}};